const fontSizes = {
    None: "",
    Small: "text-sm",
    XSmall: "text-xs",
    Large: "text-lg",
    XLarge: "text-xl",
    XXSmall: "text-[10px]",
};

const fontSizeStyles = {
    None: {},
    Small: { fontSize: "14px" },
    XSmall: { fontSize: "12px" },
    Large: { fontSize: "18px" },
    XLarge: { fontSize: "20px" },
    XXLarge: { fontSize: "24px" },
    XXSmall: { fontSize: "10px" },
};

//TODO: implement other colours
const colours = {
    BorderLight: "border-skin-light",
    Divider: "border-skin-divider",
    Succeed: "border-green-600",
    Error: "border-red-600",
};

const borderColours = {
    BorderLight: "border-skin-light",
    Divider: "border-skin-divider",
    Succeed: "border-green-600",
    Error: "border-red-600",
};

const bgColors = {
    Default: 'bg-skin-base',
    BgDefault: 'bg-skin-base',
    PrimaryDark: 'bg-skin-primary-dark',
    GreyDark: 'bg-skin-grey-dark',
    GreyLight: 'bg-skin-grey-light',
    SpecialTeal: 'bg-skin-special-teal',
    PrimaryLight: 'bg-skin-primary-light'
};

export const getBgColorCss = (name) => {
    return bgColors[name] ?? null;
};


const radiusSizes = {
    XSmall: '6px',
    Small: '12px',
    Medium: '15px',
    Large: '20px',
    XLarge: '30px',
    XXLarge: '40px',
};

const textColours = {
    BorderLight: "text-skin-light",
    BorderLight: "text-skin-light",
    Divider: "text-skin-divider",
    Succeed: "text-green-600",
    Error: "text-red-600",
    Highlight: "text-skin-primary",
    HighlightDark: "text-skin-dark",
    PrimaryInvert: "text-skin-invert"
};

export const getFontSizeCss = (fontSize) => {
    if (!fontSize) return null;
    return fontSizes[fontSize];
};

export const getFontSizeStyle = (fontSize) => {
    if (!fontSize) return null;
    return fontSizeStyles[fontSize];
};

export const getColourCss = (colourName) => {
    if (!colourName) return null;
    return colours[colourName] ?? "border-skin-light";
};

export const getBorderColourCss = (colourName) => {
    if (!colourName) return null;
    return borderColours[colourName] ?? "border-skin-light";
};

export const getTextColourCss = (colourName) => {
    if (!colourName) return null;
    return textColours[colourName] ?? "text-base";
};

export const getBorderRadiusSizeCss = (name) => {
    if (!name) return null;
    return radiusSizes[name] ?? null;
};
